import axios from '@lib/axios';
import { useMutation, useQueryClient, } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export interface Inputs {
  type: string;
  name: string;
  logo: string;
  logoShare: string;
  color: string;
  colorTitle: string;
  footerImage?: string;
  footerDescription?: string;
  guidelines?: string;
  footerLinkedInUrl?: string;
  footerSiteUrl?: string;
  footerEmail?: string;
}

interface SaveRecipientProps {
  contentGroupId?: string;
	onSuccess?: (data: AxiosResponse) => void;
  onError?: (error: AxiosResponse) => void;
}

export const useSaveContentGroup = ({
  contentGroupId,
	onSuccess,
  onError
}: SaveRecipientProps) => {
  const queryClient = useQueryClient();
	const {
		isPending,
		isError,
		error,
		mutate: onSaveContentGroup,
	} = useMutation({
		mutationFn: async (inputs: Inputs) => {
      if (contentGroupId)
        return axios.patch(`/content-groups/${contentGroupId}`, inputs);
      
      return axios.post('/content-groups', inputs);
		},
		onSuccess: (data) => {
      if (contentGroupId)
        queryClient.invalidateQueries({ queryKey: ['contentGroup', contentGroupId] });
      if (onSuccess)
        onSuccess(data);
    },
    onError
	});

	return { onSaveContentGroup, isPending, isError, error };
};
